module.exports = __webpack_public_path__ + "img/2_121.ae897246.png";